<template>

    <Head>
        <title>Apoyo Covid</title>
    </Head>
    <div class="hero-img-overlay " style="background-image: url('/img/hero-comisiones.png');">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-lg-7">
                    <h1 class="hero-encabezado">Apoyo Covid</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="bloque-general">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-4">
                    <div class="tarjeta-integrante">
                        <div class="tarjeta-integrante_inner">
                            <i class="fi fi-file-1 mb-2"></i>
                            <div class="tarjeta-integrante_datos">
                                <div class="tarjeta-integrante_nombre">Información Completa</div>
                            </div>
                        </div>
                        <div class="tarjeta-integrante_contacto">
                            <div class="">
                                <a href="/descargas/Santiago__completo.xlsx" class="boton-secundario boton-flecha">Descargar</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="tarjeta-integrante">
                        <div class="tarjeta-integrante_inner">
                            <i class="fi fi-file-1 mb-2"></i>
                            <div class="tarjeta-integrante_datos">
                                <div class="tarjeta-integrante_nombre">Información Relevante</div>
                            </div>
                        </div>
                        <div class="tarjeta-integrante_contacto">
                            <div class="">
                                <a href="/descargas/Santiago__relevante.xlsx" class="boton-secundario boton-flecha">Descargar</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="tarjeta-integrante">
                        <div class="tarjeta-integrante_inner">
                            <i class="fi fi-link mb-2"></i>
                            <div class="tarjeta-integrante_datos">
                                <div class="tarjeta-integrante_nombre">Mas Información</div>
                            </div>
                        </div>
                        <div class="tarjeta-integrante_contacto">
                            <div class="">
                                <a href="https://tacnl.org.mx/" target="_blank" class="boton-secundario boton-flecha">Abrir</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {

}
</script>
<style scoped>
.fi-file-1{
    font-size: 1.7rem;
}
.tarjeta-integrante_inner{

    display: flex;
    flex-direction: column;

}
</style>
